module.exports = __webpack_public_path__ + "static/media/KegstarLogo_Star.211f8819.svg";